<template>
  <div class="container h-100">
    <div class="d-flex justify-content-center h-100">
      <div class="user_card">
        <div class="d-flex justify-content-center">
          <div class="brand_logo_container">
            <img
              src="images/logo.jpg"
              class="brand_logo"
              alt="Logo"
            />
          </div>
        </div>
        <div class="d-flex justify-content-center form_container">
          <form class="login-form">
            <div class="input-group mb-2">
              <div class="input-group-append">
                <span class="input-group-text"
                  ><i class="fas fa-envelope"></i
                ></span>
              </div>
              <input type="email" name="" class="form-control input_user" @keyup="validateEmail" v-model="email" @keyup.enter="Login" placeholder="Email"/>
            </div>
            <div v-if="e_error" class="alertError">{{ e_error }}</div>
            <div class="input-group mb-2">
              <div class="input-group-append">
                <span class="input-group-text"><i class="fas fa-key"></i></span>
              </div>
              <input type="text" v-if="showPassword" name="" class="form-control input_pass" v-model="password" @keyup.enter="Login" placeholder="Password"/>
              <input type="password" v-else name="" class="form-control input_pass"  v-model="password" @keyup.enter="Login" placeholder="Password"/>
              <i class="fas" @click="toggleShow" :class="{ 'fa-eye': showPassword, 'fa-eye-slash' : !showPassword }"></i> 
            </div>
            <!-- <div v-if="p_error" class="alertError">{{ p_error }}</div> -->
            <div class="d-flex justify-content-center mt-3 login_container">
              <DoubleBounce  v-if="showLoader"></DoubleBounce>
              <button type="button" v-on:click="Login" name="button" v-else class="btn login_btn">
                Login
              </button>
            </div>  
          </form>
        </div>

        <div class="mt-4">
          <div class="d-flex justify-content-center links">
            <router-link to="/forgot" class="white">Forgot password?</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {DoubleBounce} from 'vue-loading-spinner'
import { defineComponent } from 'vue'
import { createToast } from 'mosha-vue-toastify';
import 'mosha-vue-toastify/dist/style.css'
import { base_url } from "../../config";
import axios from "../../services/customAxios";
export default defineComponent({
  name:'Login',
  components: { DoubleBounce },
  setup () {
    const toast = () => {
        createToast()
    }
    return { toast }
  },
  data() {
    return {
      email: "",
      password: "",
      e_error:"",
      p_error:"",
      showLoader:false,
      showPassword:false,
      base_url: base_url,
    };
  },
  methods:{
    toggleShow() {
      this.showPassword = !this.showPassword;
    },
    async Login() {
      this.showLoader = true
      try{
        let response = await axios.post(`${base_url}/login`, {
          email: this.email,
          password: this.password,
        });
        console.log("check result==>", response.data.result.token);
        let auth = response.data.result;
        localStorage.setItem('token', auth.token)
        createToast({title: "Success", description: response.data.message},{type: "success"})
        this.$router.push({ name: "Dashboard2" });
      }
      catch(error){
        this.showLoader = false
        console.error("An error occurred:", error);
        createToast({title: "Error", description: error?.response?.data?.message},{type: "danger"})
      }
    },
    validateEmail() {
      if (!/\S+@\S+\.\S+/.test(this.email)) {
        this.e_error = 'Please enter a valid email address.';	
      } 
      else {
       this.e_error = '';
      }
    },
    validatePass(){
      if(!/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[!@#&*~]).{8,16}$/.test(this.password)) {
        this.p_error = 'Password must have at least 8 Characters long.';	
      }else{
        this.p_error = '';
      }
    },
  },
  mounted() {
    let admin = localStorage.getItem("token");
    console.log("admin",admin)
    if (admin) {
      this.$router.push({ path: "/dashboard" });
    }
  },
});
</script>

<style>
.white{
  color: white;
}
.alertError{
  color: black;
  font-size: 14px;
  margin-bottom: 0;
  margin-top: 0;
}
</style>
<style scoped>
i.fas.fa-eye-slash,
i.fas.fa-eye {
   position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    color: #3a494b;
    right: 10px;
    z-index:99
}
</style>